import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { RelayEnvironmentProvider } from '@atlassian/relay-environment-provider';
import { OnboardingMenu } from '@atlassian/global-side-navigation';

import { useNav4FeedbackCollectorActions } from '@confluence/nav4-feedback';

export const Nav4OnboardingMenu = () => {
	const intl = useIntl();
	const { openFeedbackCollector } = useNav4FeedbackCollectorActions();

	return (
		<RelayEnvironmentProvider>
			<OnboardingMenu
				ariaLabel={intl.formatMessage(i18n.onboardingMenuAriaLabel)}
				buttonLabel={intl.formatMessage(i18n.onboardingMenuButtonLabel)}
				startTour={() => {}}
				openFeedbackCollector={openFeedbackCollector}
			/>
		</RelayEnvironmentProvider>
	);
};

const i18n = defineMessages({
	onboardingMenuButtonLabel: {
		id: 'page-layout.nav4.onboarding-menu.button-label',
		defaultMessage: 'Get help with navigation',
		description:
			'Text for button to open the nav4 onboarding menu which has guided tour, feedback collector and link to read about the new navigation',
	},
	onboardingMenuAriaLabel: {
		id: 'page-layout.nav4.onboarding-menu.aria-label',
		defaultMessage: 'Navigation help and onboarding menu',
		description:
			'ARIA label for button to open the nav4 onboarding menu which has guided tour, feedback collector and link to read about the new navigation',
	},
});
